import React, { useState, useEffect } from 'react';
import './Nav.css';
import { AiOutlineHome, AiOutlineUser } from 'react-icons/ai';
import { BiBook, BiMessageSquareDetail } from 'react-icons/bi';
import { HiOutlineBookOpen } from 'react-icons/hi';
import { LuBriefcase } from 'react-icons/lu';

const links = [
  { href: '#top', label: 'Home', icon: <AiOutlineHome /> },
  { href: '#about', label: 'About', icon: <AiOutlineUser /> },
  { href: '#experience', label: 'Stack', icon: <BiBook /> },
  { href: '#journey', label: 'Experience', icon: <LuBriefcase /> },
  { href: '#portfolio', label: 'Projects', icon: <HiOutlineBookOpen /> },
  { href: '#contact', label: 'Contact', icon: <BiMessageSquareDetail /> },
];

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#top');

  useEffect(() => {
    const ids = links.map((l) => l.href.slice(1));
    const onScroll = () => {
      const y = window.scrollY + 120;
      let current = '#top';
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= y) current = `#${id}`;
      });
      setActiveNav(current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className="nav">
      {links.map(({ href, label, icon }) => (
        <a
          key={href}
          href={href}
          onClick={() => setActiveNav(href)}
          className={activeNav === href ? 'active' : ''}
          aria-label={label}
        >
          {icon}
          <span className='nav__tooltip'>{label}</span>
        </a>
      ))}
    </nav>
  );
};

export default Nav;
